import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { TypeChecker } from '../../../shared/classes/type-checker';
import { BaseControl } from '../../../shared/classes/form-base-controls';
import { ISelectOption } from '../../../services/form-builder/form.interface';

@Component({
  selector: 'app-checkbox-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    CheckboxModule
  ],
  template: `
    <div [formGroup]="checkboxGroup" *ngIf="typeChecker.isCheckbox(control)" 
      class="flex flex-wrap gap-1" [ngClass]="{'flex-column': !control.showHorizontal, 'flex-row': control.showHorizontal}">
      <div *ngFor="let option of control.displayedOptions">
        <p-checkbox name="group" [value]="option.value" [label]="option.text" binary="true" 
          (onChange)="onCheckboxChange($event, option)" [formControlName]="option.value"></p-checkbox>
      </div>        
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `
})
export class CheckboxControlComponent implements OnInit {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;
  checkboxGroup: FormGroup;
  selectedValues: any[] = []

  constructor(private readonly fb: FormBuilder) {
    this.checkboxGroup = this.fb.group({});
  }
  
  ngOnInit() {
    if (!TypeChecker.isCheckbox(this.control)) return;
    const controlValues = this.getControlValue();
    this.control.displayedOptions.forEach(option => {
      const control = new FormControl({ value: controlValues.includes(option.value), disabled: this.control.disable });
      this.checkboxGroup.addControl(option.value, control);
    });
    this.control.resetEvent.subscribe(() => {
      Object.keys(this.checkboxGroup.controls).forEach(key => {
        this.checkboxGroup.get(key)?.setValue(false);
      });
    });
  }

  getControlValue(): string[] {
    const control = this.formGroup.get(this.control.name);
    let values: string[] = [];
    if (control?.value)
      values = control.value.split(',');
    return values;
  }

  getCheckedValues(): string[] {
    return Object.keys(this.checkboxGroup.value).filter(key => this.checkboxGroup.value[key]);
  }

  onCheckboxChange(event: any, option: ISelectOption) {
    const control = this.formGroup.get(this.control.name);
    let multiSelect = true;
    if (TypeChecker.isCheckbox(this.control) && TypeChecker.hasMultiSelect(this.control)){
      multiSelect = this.control.multiSelect;
    }
    
    if(multiSelect){    
      let checkedValues = this.getCheckedValues();
      control?.setValue(checkedValues.toString());
    } else {
      Object.keys(this.checkboxGroup.controls).forEach(key => {
        if (key !== option.value) {
          this.checkboxGroup.get(key)?.setValue(false);
        }
      });
      if (event.checked) {
        control?.setValue(option.value);
      } else {
        control?.setValue('');
      }
    }
  }

}
